import { useStyles } from './styles'
import { $userLanguage, $userToken } from '@/entities/user'
import { useUnit } from 'effector-react'
import { lang } from '@/shared/constants/lang'
import { BackgroundShading } from '@/shared/ui/backgroundShading'
import { ProfileCard } from '@/features/unifiedProfileCard'
import { Statistics } from '@/shared/ui/dataWrappers/farcanaStatistics'
import { useCallback, useEffect, useMemo } from 'react'
import { useHideNav } from '@/shared/hooks/useHideNav'
import { useBackButton } from '@/shared/hooks/useBackButton'
import AppLoading from '@/features/loading'
import useGetEpicStats from './hooks/useGetEpicStats'
import { EGSGamesList } from '@/features/profileTabs/gameList'
import { EGSGame } from '@/entities/user'
import { getUserProfileFx } from '@/entities/user'
import { UpdateProgressButton } from '@/features/updateProgressButtons'
import { goToMain } from '@/app/routing/events'
import { usePolling } from '@/shared/hooks/usePolling'
import useGetRefreshingStatus from '@/shared/hooks/useGetRefreshingStatus'
import { $epicUserData } from '@/entities/platforms/egs/store'

export const EpicProfileView = () => {
  useHideNav()
  const userToken = useUnit($userToken)
  const handlebb = useCallback(() => goToMain(), [])
  useBackButton({ onBack: handlebb })
  const { isEpicRefreshing } = useGetRefreshingStatus()

  const userLang = useUnit($userLanguage)
  const statistics = useUnit($epicUserData)
  const epicStats = useGetEpicStats()

  const epicFavGames: EGSGame[] = useMemo(() => {
    if (!statistics || !statistics.games) return []
    const g = [...statistics.games].sort((a, b) => b.xp_earned - a.xp_earned).slice(0, 5)
    return g
  }, [statistics])

  usePolling(
    () => {
      if (!userToken) return
      getUserProfileFx(userToken)
    },
    1000,
    !!userToken && isEpicRefreshing
  )

  const epicFavGamesExist = useMemo(() => {
    if (!statistics) return false
    return statistics?.games.length > 0
  }, [statistics])

  useEffect(() => {
    if (!userToken) return
    if (!statistics) getUserProfileFx(userToken)
  }, [statistics, userToken])

  const texts = lang[userLang].pages.epicProfile

  const { classes } = useStyles()

  if (!statistics) return <AppLoading />

  return (
    <div className={classes.root}>
      <div className={classes.bannerContainer}>
        <span className={classes.connectedText}>{texts.connectedSuccessfully}</span>
        <BackgroundShading
          bottom="0px"
          height="80px"
          background={'linear-gradient(0deg, #1D1E22 0%, rgba(29, 30, 34, 0.60) 52%, rgba(29, 30, 34, 0.00) 100%)'}
          zIndex={1}
        />
      </div>
      <div className={classes.contentWrapper}>
        <ProfileCard balance={statistics.epic_gigi} />
        <UpdateProgressButton />

        <p className={classes.title}>{texts.legacy}</p>
        <div className={classes.statsList}>
          {epicStats.map((stat) => (
            <Statistics
              key={stat.name}
              value={stat.value}
              difference={Number(stat.diff)}
              name={stat.name}
            />
          ))}
        </div>
      </div>
      <div className={classes.favgamesWrapper}>
        <p className={classes.title}>{texts.favgames}</p>
        <br />
        {epicFavGamesExist ? (
          <EGSGamesList gamesList={epicFavGames} />
        ) : (
          <p className={classes.noGames}>{texts.noGames}</p>
        )}
      </div>
    </div>
  )
}
